"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends4 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _invariant = _interopRequireDefault(require("invariant"));

var _useParentalChange = _interopRequireDefault(require("./useParentalChange"));

function FormikExtendedHandlers(_ref) {
  var children = _ref.children,
      errors = _ref.errors,
      handleBlur = _ref.handleBlur,
      frmkHanldeChange = _ref.handleChange,
      handleReset = _ref.handleReset,
      handleSubmit = _ref.handleSubmit,
      render = _ref.render,
      setValues = _ref.setValues,
      values = _ref.values,
      frmkProps = (0, _objectWithoutProperties2.default)(_ref, ["children", "errors", "handleBlur", "handleChange", "handleReset", "handleSubmit", "render", "setValues", "values"]);

  var reasErrors = _react.default.useMemo(function () {
    var ownerErrors = errors || {};
    return Object.keys(ownerErrors).reduce(function (acc, key) {
      return (0, _extends4.default)({}, acc, (0, _defineProperty2.default)({}, key, ownerErrors[key]));
    }, {});
  }, [errors]);

  var handleChange = _react.default.useCallback(function (field) {
    (0, _invariant.default)(typeof field === 'string', 'FormikExtended.onChange require `field` to be defined.');
    return function (value) {
      var nextValues = (0, _extends4.default)({}, values, (0, _defineProperty2.default)({}, field, value));
      setValues(nextValues);
    };
  }, [setValues, values]);

  var parentalChange = (0, _useParentalChange.default)(setValues, values);
  return (children || render)((0, _extends4.default)({}, frmkProps, {
    errors: reasErrors,
    onBlur: handleBlur,
    onChange: handleChange,
    onSubmit: handleSubmit,
    onReset: handleReset,
    parentalChange: parentalChange,
    setValues: setValues,
    values: values
  }));
}

FormikExtendedHandlers.propTypes = {
  children: _propTypes.default.func,
  errors: _propTypes.default.shape({}),
  handleBlur: _propTypes.default.func.isRequired,
  handleChange: _propTypes.default.func.isRequired,
  handleReset: _propTypes.default.func.isRequired,
  handleSubmit: _propTypes.default.func.isRequired,
  render: _propTypes.default.func,
  setValues: _propTypes.default.func.isRequired,
  values: _propTypes.default.shape({})
};
FormikExtendedHandlers.defaultProps = {
  children: undefined,
  errors: {},
  render: undefined,
  values: {}
};
var _default = FormikExtendedHandlers;
exports.default = _default;